export const GOAL_TYPES = {
  COMPANY: 'company',
  TEAM: 'team',
};

export const GOAL_PERIODS = {
  FISCAL_YEAR: 'FY',
  QUARTER: 'Q',
};

export const GOAL_PROJECTS_TABLE_COLUMNS = {
  ID: 'project_number',
  TITLE: 'project_title',
  STATUS: 'project_status',
  OWNER: 'project_owners',
  PROGRESS: 'project_progress',
  START_DATE: 'project_start_date',
  TARGET_COMPLETION_DATE: 'project_target_completion_date',
};
